const workoutPageTranslations = {
  intro: {
    title: "Crush Limits \n Break Powers.",
    description:
      "Explore your custom crafted workout program that is tailored to your goals.",
  },
  steps: {
    warmUp: "Warm Up",
    exercises: "Exercises",
    staticStretches: "Static Stretches",
  },
};

export default workoutPageTranslations;
